import { init as initApi } from '@sloyd/api';
import type { ISloydStore } from '@sloyd/store-base';
import { actions, initialState } from '@sloyd/store-base';
import { generateStore } from 'initial-state';
import p from '../package.json';
import { midConnected } from './middleware/midConnected';
import { root as rootSaga } from './sagas/manage.sagas';

const env = import.meta.env;
const isProd = env.MODE === 'production';

// @ts-ignore
initApi(isProd, {}, p.version);

export const initStore = (name: string, settings: ISettings) => {
  const { store } = generateStore<ISloydStore>(initialState, [midConnected as any], rootSaga);
  store.dispatch(actions.projects.setAll({}));
  store.dispatch(actions.settings.setAll({ ...settings }));
  return store;
};
